const extensionId = process.env.EXT_ID;

export default class TokensStorage {
  static getItem(key) {
    return localStorage.getItem(key);
  }

  static setItem(key, value) {
    window.postMessage({ type: extensionId, message: 'SET_TO_EXTENSION_STORAGE', key, value }, '*');
    localStorage.setItem(key, value);
  }

  static removeItem(key) {
    window.postMessage({ type: extensionId, message: 'REMOVE_FROM_EXTENSION_STORAGE', key }, '*');
    localStorage.removeItem(key);
  }

  static clear() {
    window.postMessage({ type: extensionId, message: 'CLEAR_EXTENSION_STORAGE' }, '*');
    const id = localStorage.getItem('typebot-id');
    localStorage.clear();
    if (id) {
      localStorage.setItem('typebot-id', id);
    }
  }
}
